module.exports = __webpack_public_path__ + "montenegro.svg?ebe9d55a4b9366e906c8ff835652ec01";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/montenegro.svg
// module id = 236
// module chunks = 10